/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitPanelDoubleImageBlockFragment, SplitPanelDoubleImageBlockFragment, FullSplitPanelDoubleImageBlockFragment} from '@amblique/contentful/app/contentful/fragments/split-panel-double-image-block';

/**
 * Get a single SplitPanelDoubleImageBlock by ID (base - scalars only)
 */
export const getBaseSplitPanelDoubleImageBlockById = gql`
  ${BaseSplitPanelDoubleImageBlockFragment}

  query GetBaseSplitPanelDoubleImageBlockById($id: String!, $locale: String!, $preview: Boolean) {
    splitPanelDoubleImageBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseSplitPanelDoubleImageBlockFragment
    }
  }
`;

/**
 * Get a single SplitPanelDoubleImageBlock by ID (standard - 1 level deep)
 */
export const getSplitPanelDoubleImageBlockById = gql`
  ${SplitPanelDoubleImageBlockFragment}

  query GetSplitPanelDoubleImageBlockById($id: String!, $locale: String!, $preview: Boolean) {
    splitPanelDoubleImageBlock(id: $id, locale: $locale, preview: $preview) {
      ...SplitPanelDoubleImageBlockFragment
    }
  }
`;

/**
 * Get a single SplitPanelDoubleImageBlock by ID (full - 2 levels deep)
 */
export const getFullSplitPanelDoubleImageBlockById = gql`
  ${FullSplitPanelDoubleImageBlockFragment}

  query GetFullSplitPanelDoubleImageBlockById($id: String!, $locale: String!, $preview: Boolean) {
    splitPanelDoubleImageBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullSplitPanelDoubleImageBlockFragment
    }
  }
`;

/**
 * Get all SplitPanelDoubleImageBlock entries with pagination (base - scalars only)
 */
export const getBaseSplitPanelDoubleImageBlocks = gql`
  ${BaseSplitPanelDoubleImageBlockFragment}

  query GetBaseSplitPanelDoubleImageBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitPanelDoubleImageBlockOrder]
    $where: SplitPanelDoubleImageBlockFilter
    $preview: Boolean
  ) {
    splitPanelDoubleImageBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSplitPanelDoubleImageBlockFragment
      }
    }
  }
`;

/**
 * Get all SplitPanelDoubleImageBlock entries with pagination (standard - 1 level deep)
 */
export const getSplitPanelDoubleImageBlocks = gql`
  ${SplitPanelDoubleImageBlockFragment}

  query GetSplitPanelDoubleImageBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitPanelDoubleImageBlockOrder]
    $where: SplitPanelDoubleImageBlockFilter
    $preview: Boolean
  ) {
    splitPanelDoubleImageBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SplitPanelDoubleImageBlockFragment
      }
    }
  }
`;

/**
 * Get all SplitPanelDoubleImageBlock entries with pagination (full - 2 levels deep)
 */
export const getFullSplitPanelDoubleImageBlocks = gql`
  ${FullSplitPanelDoubleImageBlockFragment}

  query GetFullSplitPanelDoubleImageBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitPanelDoubleImageBlockOrder]
    $where: SplitPanelDoubleImageBlockFilter
    $preview: Boolean
  ) {
    splitPanelDoubleImageBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSplitPanelDoubleImageBlockFragment
      }
    }
  }
`;
